import { render } from "./ResultadosComponent.vue?vue&type=template&id=e8ed5aa0&scoped=true"
import script from "./ResultadosComponent.vue?vue&type=script&lang=js"
export * from "./ResultadosComponent.vue?vue&type=script&lang=js"

import "./ResultadosComponent.vue?vue&type=style&index=0&id=e8ed5aa0&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8ed5aa0"]])

export default __exports__